import React, { useContext } from "react";
import { TableHeaderContext } from "../../Contexts/TableHeaderContext";
import Loader from "../Loader";
import { NavLink } from "react-router-dom";
import routePathSegments, { routeNames } from "../../routeSegments";
import useModule from "../../hooks/useModule";

const FundProfile = ({ data }) => {
  const { isVC } = useModule();

  const { profile, other_funds } = data || {};
  const { fundProfileKeys } = useContext(TableHeaderContext);

  const getLimitedPartners = (LP) => {
      if (!LP || LP.length === 0) return null;
  
      return (
        <span>
          {LP.map((partner, index) =>
            partner.id && partner.id !== "" ? (
              <span key={partner.id}>
                <NavLink
                  target="_blank"
                  href={routeNames.investorsLimitedPartnerById(partner.id)}
                  className={"underline text-[#bc8b20]"}
                  rel="noopener noreferrer"
                >
                  {partner.name}
                </NavLink>
                {index < LP.length - 1 && ", "}
              </span>
            ) : (
              <span key={partner.id} className="cursor-default">
                {partner.name}
                {index < LP.length - 1 && ", "}
              </span>
            )
          )}
        </span>
      );
    };
  const getFundReturnSource = (source,source_link) => {
      if (!source || source.length === 0) return null;
  
      return (
        <span> 
          {source.split('|').map((src, index) => (
            <>
            {index !== 0 ? ', ' : ' '}
            {source_link !== null ? (
              <a
                href={source_link.split('|')[index] || '#'}
                target="_blank" className="underline">{src.trim()}
              </a>
            ) : (
              <span>{src.trim()}</span>
            )}
            </>
          ))}
        </span>
      );
    };

  return (
    <div className="lg:mt-4 px-4 w-[100%]">
      <div className="lg:bg-white rounded-[6px]" x-show="tab === 1">
        <div className="w-full lg:grid lg:grid-cols-5 rounded-[6px] shadow-[0_2px_6px_0_rgba(0,0,0,0.08)]">
          {/* <div className={`${other_funds?.length !== 0 ? "col-span-3" : "col-span-5"} mt-3 lg:mt-0 rounded-lg lg:rounded lg:border-r bg-white `}> */}
          <div className={`col-span-5 mt-3 lg:mt-0 rounded-lg lg:rounded lg:border-r bg-white `}>
            <div className="mx-5 py-4 ">
              <p className="flex text-[14pt] leading-[19pt] lg:text-[17px] text-[#333333] font-semibold lg:leading-[22px]">
                Profile
              </p>
              <div className="w-full bg-[#FFFFFF]">
                <div className="grid grid-cols-2 md:grid-cols-5">
                    {fundProfileKeys?.map((keyObj, index) => {
                      const key = keyObj.accessor;
                      const label = keyObj.label;
                      let valueToRender = profile[key] === 0 || profile[key] === null ? null : profile[key];

                      if(key === "limited_partners"){
                        if(profile[key]?.length === 0){
                          valueToRender = null 
                        } else valueToRender = getLimitedPartners(profile[key])
                      }else if(key === "fund_level_return"){
                        if(profile['source'] === null){
                          valueToRender = profile[key] === 0 || profile[key] === null ? null : profile[key];
                        } else {
                          const source = getFundReturnSource(profile['source'], profile['source_link']);
                            valueToRender = profile[key] === 0 || profile[key] === null ? source : (
                              <span>
                                {profile[key]} ({source})
                              </span>
                            );
                          } 
                      }

                      if(valueToRender !== null){
                        return (
                          <div key={index} className={`profiletable`}>
                            <>
                              <div className="leading-[21px] font-sans_book_body mt-1">
                                <div class=" block lg:overflow-x-clip lg:overflow-ellipsis lg:whitespace-nowrap md:max-w-[14rem]">
                                  <span
                                    className="py-1 text-[10pt] lg:whitespace-nowrap leading-[18pt] lg:text-[13px] text-[#333333] cursor-auto"
                                    readOnly
                                  >
                                    {label}
                                  </span>
                                </div>
                                <p
                                  className="mt-1 mb-2 w-[90%] text-[10pt] leading-[18pt] lg:text-[13px] text-[#333333] cursor-auto font-semibold"
                                  readOnly
                                >
                                  {valueToRender ?? "--"}
                                </p>
                              </div>
                            </>
                          </div>
                        );
                      }
                    })}
                </div>
              </div>
            </div>
          </div>
          {/* {other_funds?.length !== 0 ? <div className="mt-3 lg:mt-0 rounded-lg lg:rounded col-span-2">
            <div className="mx-5 py-4 ">
            <p className="flex text-[14pt] leading-[19pt] lg:text-[17px] text-[#333333] font-semibold lg:leading-[22px]">
              Other Funds
            </p>
                <div className="mt-2">
                  {other_funds?.map((fund, index) => (
                    <NavLink to={isVC ? routeNames.vc_investors_funds_page(fund.fundId) : routeNames.pe_investors_funds_page(fund.fundId)}>
                      <div key={index} className={`${other_funds?.length - 1 === index ? "" : " border-b"} flex py-4`}>
                        <span className="text-[12pt] lg:text-[14px] text-[#333333] font-sans_book_body min-w-[22rem]">
                          {fund.fundName}
                        </span>
                        <span className="text-[12pt] lg:text-[14px] text-[#333333] font-sans_book_body">
                          {fund.fund_date}
                        </span>
                      </div>
                    </NavLink>
                  ))}
                </div>
          </div>
          </div> : null} */}
        </div>
      </div>
    </div>
  );
};

export default FundProfile;